import { Cookies } from 'react-cookie';

import { CapacityAnalyticsParams, CapacityAnalyticsResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrapCapacityAnalytics = async (
  trapSlug: string,
  params: CapacityAnalyticsParams,
  signal?: AbortSignal,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const queryParams: Record<string, string> = {
    date_from: params.date_from,
    date_to: params.date_to,
  };

  if (params.event_type && params.event_type !== 'all') {
    queryParams.event_type = params.event_type;
  }

  const response = await axiosInterceptor.get<CapacityAnalyticsResponse>(
    `api/v1/traps/${trapSlug}/capacity-analytics`,
    {
      headers: {
        Authorization: token,
      },
      params: queryParams,
      signal,
    },
  );

  return response.data;
};
